import type { SVGProps } from 'react';

const SVGComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width={18}
    height={18}
    viewBox='0 0 18 18'
    fill='none'
    {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M9 4.5L7.5 3H3C2.175 3 1.5075 3.675 1.5075 4.5L1.5 13.5C1.5 14.325 2.175 15 3 15H15C15.825 15 16.5 14.325 16.5 13.5V6C16.5 5.175 15.825 4.5 15 4.5H9ZM3 13.5H15V6H9C8.60218 6 8.22064 5.84196 7.93934 5.56066L6.87868 4.5H3.0075L3 13.5Z'
      fill='#696F88'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M10.371 7.66966L10.4218 7.6602L10.4349 7.6578C10.8955 7.57326 11.2941 7.52094 11.4608 7.5C11.3489 7.68174 11.2946 7.80492 11.2266 7.95904L11.2085 8C11.1535 8.12754 11.0964 8.28157 11.0382 8.46836C10.9656 8.70163 10.8912 8.986 10.8168 9.33371C10.8077 9.37649 10.7986 9.42084 10.7892 9.46648C10.6953 9.92088 10.5752 10.5026 10.2588 10.9286C9.86033 11.4665 9.41948 11.6886 8.78444 11.798C8.36033 11.8705 7.96078 11.8996 7.64047 11.9219L7.60179 11.9246C7.39313 11.9391 7.19666 11.9527 6.98533 12C6.92018 11.766 6.86853 11.5397 6.83324 11.3206C6.82225 11.2524 6.81284 11.1849 6.80511 11.1181C6.76283 10.7528 6.77059 10.4084 6.84248 10.0837C6.96301 9.54241 7.2052 9.16853 7.5735 8.82812C8.1427 8.30134 8.97529 7.97656 9.88377 7.77009C10.048 7.73287 10.2126 7.6994 10.371 7.66966ZM10.0513 8.65503C9.21577 8.8482 8.57745 9.12537 8.18497 9.48861C7.93565 9.71904 7.79762 9.93615 7.72124 10.2787C7.67509 10.4875 7.66617 10.7291 7.69941 11.0154C7.98799 10.9945 8.30408 10.967 8.63234 10.9109C8.88456 10.8674 9.04466 10.8105 9.16485 10.742C9.27974 10.6765 9.3992 10.5772 9.5357 10.3929L9.53646 10.3918C9.72829 10.1336 9.81003 9.7463 9.91773 9.23596L9.93687 9.1454C9.97446 8.96968 10.0126 8.80657 10.0513 8.65503Z'
      fill='#696F88'
    />
  </svg>
);
export default SVGComponent;
